import { Routes } from '@angular/router';
import {
	PrivatePagesWrapperComponent
} from '@infodocs/shared/components/private-pages-wrapper/private-pages-wrapper.component';
import {
	PublicPagesWrapperComponent
} from '@infodocs/shared/components/public-pages-wrapper/public-pages-wrapper.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { BillingAccessGuard } from '../shared/guards/billing-access.guard';

export const accountRoutes: Routes = [
	{
		path: '',
		canActivate: [AuthGuard],
		component: PrivatePagesWrapperComponent,
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/account-page/account-page.component').then(m => m.AccountPageComponent)
			},
			{
				path: 'users',
				loadComponent: () => import('./pages/users-page/users-page.component').then(m => m.UsersPageComponent)
			},
			{
				path: 'billing',
				canActivate: [BillingAccessGuard],
				loadComponent: () => import('./pages/billing-page/billing-page.component').then(m => m.BillingPageComponent)
			},
			{
				path: 'cipctransactions',
				loadComponent: () => import('./pages/cipc-transactions-page/cipc-transactions-page.component').then(m => m.CipcTransactionsPageComponent)
			},
			{
				path: 'cipctransactions/:id',
				loadComponent: () =>
					import('./pages/cipc-transaction-detail-page/cipc-transaction-detail-page.component').then(
						m => m.CipcTransactionDetailPageComponent
					)
			},
			{
				path: 'summary',
				loadComponent: () => import('./pages/summary-page/summary-page.component').then(m => m.SummaryPageComponent)
			},
		]
	},
	{
		path: '',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: 'cancelled',
				loadComponent: () =>
					import('./pages/account-cancelled-page/account-cancelled-page.component').then(
						m => m.AccountCancelledPageComponent
					),
				data: {
					headerType: 'withLogin'
				}
			},
			{
				path: 'register',
				loadComponent: () => import('./pages/register-page/register-page.component').then(m => m.RegisterPageComponent),
				data: {
					headerType: 'withLogin'
				}
			},
			{
				path: 'login',
				loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent),
				data: {
					headerType: 'simple'
				}
			},
			{
				path: 'reset-password',
				loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
				data: {
					headerType: 'simple'
				}
			},
			{
				path: 'set-password/:token',
				loadComponent: () => import('./pages/set-password-page/set-password-page.component').then(m => m.SetPasswordPageComponent),
				data: {
					headerType: 'simple'
				}
			},
			{
				path: '**',
				loadComponent: () => import('../public/pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
				data: { headerType: 'withLogin' },
			},
		]
	},
	{
		path: 'payment/:paymentId',
		loadComponent: () => import('./pages/peach-payment-page/peach-payment-page.component').then(m => m.PeachPaymentPageComponent)
	},
];
